import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ComplaintIcon from '@mui/icons-material/ReportProblem';
import QrCodeIcon from '@mui/icons-material/QrCode';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const ItemDrawer = ({ open, onClose, item, onEdit, onRaiseComplaint, onGenerateQRCode }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: isMobile ? '10px' : '20px',
          padding: isMobile ? '10px' : '20px',
        },
      }}
    >
      <DialogTitle>
        <Typography variant={isMobile ? "subtitle1" : "h6"} style={{ fontWeight: 'bold' }}>Item Details</Typography>
        <IconButton onClick={onClose} aria-label="Close dialog" style={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {item && item.imageUrl && (
          <Box mb={isMobile ? 2 : 3}>
            <Paper elevation={3} style={{ padding: '10px', borderRadius: '10px' }}>
              <img
                src={item.imageUrl}
                alt={item.itemName}
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '5px',
                  objectFit: 'contain',
                  maxHeight: isMobile ? '200px' : '300px',
                }}
              />
            </Paper>
          </Box>
        )}

        {item ? (
          <Box>
            <Typography variant={isMobile ? "subtitle1" : "h4"} style={{ fontWeight: 'bold', marginBottom: isMobile ? '5px' : '10px', color:'#1976d2' }}>
              {item.itemMake}
            </Typography>
            
            <Divider style={{ marginBottom: isMobile ? '10px' : '15px' }} />

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}><strong>Item ID:</strong></Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}>{item.id}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}><strong>Model:</strong></Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}>{item.model}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}><strong>Customer Name:</strong></Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}>{item.customerName}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}><strong>Product Name:</strong></Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}>{item.productName}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}><strong>Facility Name:</strong></Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}>{item.facilityName}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}><strong>Branch Name:</strong></Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}>{item.branchName}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}><strong>Region:</strong></Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}>{item.facilityRegion}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}><strong>Admin Phone Number:</strong></Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}>{item.facilityPhoneNumber}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}><strong>Admin Email:</strong></Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}>{item.facilityEmail}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}><strong>Warranty Period:</strong></Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}>{item.warrantyPeriod}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}><strong>Purchase Date:</strong></Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}>{item.purchaseDate}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}><strong>Warranty Expiry Date:</strong></Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={isMobile ? "body2" : "body1"}>{item.warrantyExpiryDate}</Typography>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Typography variant={isMobile ? "body2" : "body1"}>No item selected</Typography>
        )}
      </DialogContent>
      {item && (
        <DialogActions style={{ justifyContent: 'center', padding: isMobile ? '10px 0' : '20px 0' }}>
          <IconButton
            variant="outlined"
            color="primary"
            onClick={() => onEdit(item.id)}
            size="small"
            style={{ borderRadius: '50%', width: isMobile ? 30 : 40, height: isMobile ? 30 : 40, padding: 8, margin: '0 10px',  color: '#1976d2' }}
            sx={{ '&:hover': { backgroundColor: 'grey', color: 'white' } }}
            aria-label={`Edit item ${item.id}`}
          >
            <EditIcon fontSize={isMobile ? "small" : "medium"} />
          </IconButton>
          <IconButton
            variant="outlined"
            color="primary"
            onClick={() => onRaiseComplaint(item.id)}
            size="small"
            style={{ borderRadius: '50%', width: isMobile ? 30 : 40, height: isMobile ? 30 : 40, padding: 8, margin: '0 10px',  color: '#b33232' }}
            sx={{ '&:hover': { backgroundColor: 'grey', color: 'white' } }}
            aria-label={`Transfer item ${item.id}`}
          >
            <ComplaintIcon fontSize={isMobile ? "small" : "medium"} />
          </IconButton>
          <IconButton
            variant="outlined"
            color="primary"
            onClick={() => onGenerateQRCode(item.id)}
            size="small"
            style={{ borderRadius: '50%', width: isMobile ? 30 : 40, height: isMobile ? 30 : 40, padding: 8, margin: '0 10px', color: 'black' }}
            sx={{ '&:hover': { backgroundColor: 'grey', color: 'white' } }}
            aria-label={`Generate QR code for item ${item.id}`}
          >
            <QrCodeIcon fontSize={isMobile ? "small" : "medium"} />
          </IconButton>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default ItemDrawer;
